/** Dispatched from Electron main or GridSearchShortcutService when F12 is handled. */
export const GRID_SEARCH_TOGGLE_EVENT = 'mediastra-grid-search-toggle';

export function isGridSearchF12Key(event: KeyboardEvent): boolean {
  return (
    event.key === 'F12' ||
    event.code === 'F12' ||
    event.keyCode === 123
  );
}

export function dispatchGridSearchToggle(): void {
  document.dispatchEvent(
    new CustomEvent(GRID_SEARCH_TOGGLE_EVENT, { bubbles: true }),
  );
}
